/**
 * ShopifyCallbackPage — /shopify-callback
 *
 * Loaded inside the OAuth popup after shopify-auth redirects here.
 * Sends postMessage to the opener then closes itself.
 * This avoids the Content-Type / charset issue with Supabase Edge Function HTML responses.
 */
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export function ShopifyCallbackPage() {
  const [searchParams] = useSearchParams();
  const shop = searchParams.get('shop') ?? '';

  useEffect(() => {
    if (window.opener && !window.opener.closed) {
      try {
        window.opener.postMessage(
          { type: 'SHOPIFY_AUTH_SUCCESS', shop },
          window.location.origin,
        );
      } catch (err) {
        // Intentionally not surfaced: the popup closes itself momentarily and the
        // integrations page re-checks connection status on its own.
        console.warn('Shopify callback postMessage failed:', err);
      }
      setTimeout(() => window.close(), 800);
    } else {
      // Not a popup — redirect to integrations page
      window.location.replace('/app/settings/integrations?shopify_connected=1');
    }
  }, [shop]);

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      minHeight: '100vh', fontFamily: 'system-ui, sans-serif',
      background: '#f0fdf4', color: '#166534',
    }}>
      <div style={{
        background: '#fff', borderRadius: 16, padding: '40px 48px',
        boxShadow: '0 4px 24px rgba(0,0,0,.08)', textAlign: 'center', maxWidth: 420,
      }}>
        <div style={{ fontSize: '3rem', marginBottom: 12 }}>✅</div>
        <h1 style={{ margin: '0 0 8px', fontSize: '1.4rem' }}>Shopify Connected!</h1>
        <p style={{ margin: 0, color: '#4b5563' }}>
          <strong>{shop}</strong> was connected successfully.<br />
          This window will close automatically…
        </p>
      </div>
    </div>
  );
}
